<div class="holder">
  <p [innerHTML]="textService.getText('suti_felugro')"></p> 
  <p>{{textService.getText('suti_adatvedelmi_1')}}<a routerLink="/privacy-policy" fragment="cookie" (click)="more()">{{textService.getText('suti_adatvedelmi_2')}}</a></p>
  <div class="buttons">
    <button (click)="allowAll()">{{textService.getText('suti_mindent_elfogad')}}</button>
    <button (click)="allowMustHave()">{{textService.getText('suti_csak_az_alapok')}}</button>
  </div>

</div>